// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"531db0dd","307":"31d6cfe0","442":"cb788dde","764":"6aea8593","972":"976ca355"}[chunkId] + ".chunk.css";
};